import { render, staticRenderFns } from "./RegisterOrderPayment.vue?vue&type=template&id=17b2bf70&scoped=true&"
import script from "./RegisterOrderPayment.vue?vue&type=script&lang=js&"
export * from "./RegisterOrderPayment.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOrderPayment.vue?vue&type=style&index=0&id=17b2bf70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2bf70",
  null
  
)

export default component.exports